import { BidExtendedModel} from "./bidding_model";


type bidHeaderProps = {
    bid: BidExtendedModel
}


export function BidHeader({bid} : bidHeaderProps){
    return <div className="columns-3 flex justify-between mb-4 mr-6 ml-7 text-sm text-gray-500">
        <div>
            <div>Project: <em>{bid.project?.name}</em></div>
            <div>Developer: <em>{bid.project?.company_name}</em></div>
        </div>
        <div>
            <div>Bid: <em>#{bid.number}</em></div>
            <div>Prepared by: <em>{bid.company_name}</em></div>
        </div>
        <div>
                  <div>{"  "}</div>
            <div>Status: <em>{bid.status}</em> </div>

        </div>

    </div>
}